
import { client } from '@/common-utils/libraries/axios/axios';
import SIM_CARD from '../apiUrls';

const mutationReassignAndUnassignSimCards = (onSuccess, onError) => {
    return {
        mutationFn: ({ simsList, reassignToCustomer }) => {
            // No reassignToCustomer means UNASSIGN otherwise it's REASSIGN
            return client.post(SIM_CARD.REASSIGN.url, { simsList, reassignToCustomer });
        },
        // onError: (error, variables, context)
        onError: (error) => {
            onError(error);
        },
        // onSuccess: (data, variables, context)
        onSuccess: () => {
            onSuccess();
        },
        // onSettled: (data, error, variables, context)
        onSettled: () => {
            // Error or success... doesn't matter!
        }
    };
};

export default mutationReassignAndUnassignSimCards;